export default {
  businessEmail: '0410', // 公司信箱
  extensionNumber: '0420', // 分機
  businessMobileNumber: '0430', // 公務手機
};



/** WEBPACK FOOTER **
 ** D:/a/1/s/src/containers/App/screens/Tube/configs/fieldCodes.js
 **/